/**
 * @file 应用管理操作弹窗通用封装入口
 * @author fightingliu
 * @created 2022.04.18
 * @modify 2022.04.20
 */
import _ from 'lodash';
import React, { forwardRef, useCallback, useImperativeHandle, useRef } from 'react';
import { FormView, message } from '@tencent/ptp-fe-common';
import { applyEdit } from 'pages/manage/application/services';
import { useTypedSelector } from 'store/index';

interface GroupProps {
  type?: string;
  id?: any;
  appTypeOptions?: [];
  appStatusOptions?: [];
  appCategoryOptions?: [];
  appSecondCategoryOptions?: [];
  auditOptions?: [];
}
// 应用导出视图
const exportGroups = (payloads: GroupProps) => {
  const { appStatusOptions = [], appCategoryOptions = [], appSecondCategoryOptions = [], auditOptions = [] } = payloads;
  return [
    {
      controls: [
        {
          name: 'category',
          type: 'select',
          label: '一级分类',
          required: true,
          config: {
            data: appCategoryOptions,
            placeholder: '请选择一级分类',
          },
          rules: [{ required: true, message: '请选择一级分类' }],
        },
        {
          name: 'second_category',
          type: 'select',
          label: '二级分类',
          required: true,
          config: {
            data: appSecondCategoryOptions,
            placeholder: '请选择二级分类',
          },
          rules: [{ required: true, message: '请选择二级分类' }],
        },
        {
          name: 'audit_status',
          type: 'select',
          label: '审核状态',
          required: true,
          config: {
            data: auditOptions,
            placeholder: '请选择审核状态',
          },
          rules: [{ required: true, message: '请选择审核状态' }],
        },
        {
          name: 'status',
          type: 'select',
          label: '应用状态',
          required: true,
          config: {
            data: appStatusOptions,
            placeholder: '请选择应用状态',
          },
          rules: [{ required: true, message: '请选择应用状态' }],
        },
      ],
    },
  ];
};

const options = ({ payloads }: any) => {
  const { type, id } = payloads;
  let submitConfig;
  let groups = {};
  switch (type) {
    case 'export':
      // 应用导出
      submitConfig = {
        action: applyEdit,
        $onRequest(params: any) {
          const retParams = {
            ...{ client_id: parseInt(id, 10) },
            ...params,
          };
          return retParams;
        },
      };
      groups = exportGroups(payloads);
      break;
    default:
      break;
  }
  return {
    submitConfig,
    groups,
  };
};
const FormDialog: (props: any, ref: any) => JSX.Element = (props: any, ref) => {
  const { id, type } = _.get(props, 'payload', {});
  const {
    manager: { appStatusOptions, appCategoryOptions, appSecondCategoryOptions, auditOptions },
  } = useTypedSelector((state) => state);
  const formRef = useRef(null);
  const handleSubmit = useCallback(async () => {
    const { form } = formRef.current || {};
    try {
      await form.validate();
    } catch (error) {
      throw error;
    }
    try {
      await form.onSubmit();
    } catch (error) {
      message.error(error.message);
      throw error;
    }
  }, []);

  useImperativeHandle(ref, () => ({
    handleSubmit,
  }));

  const payloads = {
    id,
    type,
    appStatusOptions,
    appCategoryOptions,
    appSecondCategoryOptions,
    auditOptions,
  };

  const customFunctions = {};

  // @ts-ignore
  return <FormView ref={formRef} options={options} payloads={payloads} customFunctions={customFunctions} />;
};
export default forwardRef(FormDialog);
